import { field } from '../types';
import { FormControl, FormHelperText, TextField } from '@mui/material';
import { getErrorText, isValid } from '..';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

type props = {
	valid: boolean;
	cField: field;
	initialValidation: any;
	handleChange: any;
};

export default function DatePicker(props: props) {
	const t = useAppSelector(selectTranslations);
	const { cField } = props;
	const { name, value, label, options, helperText } = cField.props;

	return (
		<FormControl key={name} fullWidth sx={cField.styleObj}>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<DesktopDatePicker
					inputFormat="dd/MM/yyyy"
					{...cField.props}
					value={value}
					onChange={(newValue) => {
						props.handleChange({ target: { name: name, value: String(newValue) } });
					}}
					renderInput={(params) => <TextField {...params} />}
				/>
			</LocalizationProvider>
			<FormHelperText>
				{isValid(props.initialValidation, cField.props.name)
					? t(getErrorText(props.initialValidation, cField.props.name))
					: helperText}
			</FormHelperText>
		</FormControl>
	);
}
